import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class GradeForm extends Component {
  render() {
    const {
      classes,
      data,
      reference,
      handleWheel,
      handleSubmit,
      handleChange,
      loading,
    } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div>
          <TextField
            name="name"
            type="text"
            label="Grade Name"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.props.gradeError ? true : false}
            helperText={this.props.gradeError}
            placeholder="Enter the name of grade"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            value={data.name}
            onChange={handleChange}
          />
          <TextField
            name="percentFrom"
            type="number"
            label="Percentage From"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Enter starting percentage"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: { min: 0, max: 100 },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            inputRef={reference.percentFromRef}
            onWheel={() => handleWheel(reference.percentFromRef)}
            value={data.percentFrom}
            onChange={handleChange}
          />
          <TextField
            name="percentTo"
            type="number"
            label="Percentage To"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Enter ending percentage"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              inputProps: { min: 0, max: 100 },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            inputRef={reference.percentToRef}
            onWheel={() => handleWheel(reference.percentToRef)}
            value={data.percentTo}
            onChange={handleChange}
          />
          <TextField
            name="gradeNumber"
            type="number"
            label="Grade"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            placeholder="Enter grade"
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            className={classes.inputWithMargin}
            inputRef={reference.gradeRef}
            onWheel={() => handleWheel(reference.gradeRef)}
            value={data.gradeNumber}
            onChange={handleChange}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            type="submit"
            aria-label="Submit"
            variant="outlined"
            className={classes.buttonStyle}
          >
            Submit
          </Button>
          {loading && <FormLoader />}
        </div>
      </form>
    );
  }
}

export default withStyles(useStyles)(GradeForm);
